import { Controller } from "@hotwired/stimulus"
import { fetch as turboFetch } from "@hotwired/turbo"
import Sortable from "sortablejs"

// Drag items between day cells to reschedule their due date.
export default class extends Controller {
  connect() {
    this.sortables = Array.from(this.element.querySelectorAll("[data-calendar-day]")).map((cell) =>
      Sortable.create(cell, {
        group: "calendar",
        animation: 150,
        draggable: "[data-item-url]",
        onEnd: (event) => this.dropped(event)
      })
    )
  }

  disconnect() {
    this.sortables?.forEach((s) => s.destroy())
  }

  async dropped(event) {
    const url = event.item.dataset.itemUrl
    const date = event.to.dataset.calendarDay
    // FD-449: revert the drag if the reschedule is rejected/fails, so the item doesn't
    // sit in the new day cell while the server still has the old date (silent divergence).
    try {
      // FD-489: turboFetch sends X-Turbo-Request-Id so the actor's own refresh
      // broadcast is deduped client-side (the drag already moved the DOM).
      const response = await turboFetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
          Accept: "application/json"
        },
        body: JSON.stringify({ target_date: date })
      })
      if (!response.ok) this.revert(event)
    } catch {
      this.revert(event)
    }
  }

  revert(event) {
    // SortableJS fires onEnd after the DOM move, so on a same-cell upward drag the item
    // sits at newIndex and its original successor has shifted to oldIndex+1; using oldIndex
    // directly would reinsert one position off. Mirrors kanban_controller's revert.
    const idx = event.from === event.to && event.newIndex < event.oldIndex ? event.oldIndex + 1 : event.oldIndex
    const ref = event.from.children[idx] || null
    event.from.insertBefore(event.item, ref)
  }
}
